import Seo from "../components/Seo";

export default function Privacy() {
  return (
    <>
      <Seo title="Privacy Policy" description="How HS Library Hangout collects, uses, and protects your information." />
      <h1>Privacy Policy</h1>
      <p>
        <em>Last updated: this policy applies to information collected through hslibraryhangout.com.</em>
      </p>

      <section className="card">
        <h2>What we collect</h2>
        <p>When you RSVP, we collect:</p>
        <ul>
          <li>Parent/guardian first name and last initial</li>
          <li>Parent/guardian email address</li>
          <li>Parent/guardian mobile number (optional)</li>
          <li>Number of teens attending and an optional grade range</li>
          <li>An optional note to the organizer (up to 500 characters)</li>
        </ul>
        <p>
          When you use our contact form, we collect your name, email address, and message. Contact form
          messages are emailed directly to the organizer and are never stored in our database or logged.
        </p>
      </section>

      <section className="card">
        <h2>How we use it</h2>
        <p>
          We use RSVP information to manage event capacity, communicate with you about the event (including
          confirmations, reminders, updates, and cancellations), and maintain a waitlist. We never sell or
          share your information with third parties, and we never share it with Oak Lawn Public Library.
        </p>
      </section>

      <section className="card">
        <h2>How we protect it</h2>
        <p>
          Email addresses are stored using reversible encoding so we can send you emails, and are also
          hashed for duplicate-RSVP detection; the hash cannot be reversed to reveal your email. Access to
          RSVP data is limited to the volunteer organizer(s) and secured behind authenticated admin access.
        </p>
      </section>

      <section className="card">
        <h2>How long we keep it</h2>
        <p>
          Unconfirmed RSVPs expire automatically after 24 hours. RSVP personal details (name, email,
          mobile, notes) are automatically removed 90 days after the event date. Non-personal attendance
          counts may be retained for historical reporting.
        </p>
      </section>

      <section className="card">
        <h2>Your rights</h2>
        <p>
          You can view, edit, or cancel your RSVP at any time using the private management link in your
          confirmation email. You may also request early deletion of your data by contacting us.
        </p>
        <p>
          <a href="/contact">Contact us</a> with any privacy questions or deletion requests.
        </p>
      </section>
    </>
  );
}
